import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Cpu, Check } from "lucide-react";

export const ModelPicker = ({ models, value, onChange }) => {
  const current = models.find((m) => m.id === value) || models[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="model-picker-trigger"
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#141415] border border-white/10 hover:bg-[#1F1F22] transition-colors text-sm"
        >
          <Cpu className="w-4 h-4 text-[#00FF66]" />
          <span className="font-medium text-white">{current?.label || "Model"}</span>
          <ChevronDown className="w-4 h-4 text-zinc-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="bg-[#141415] border-white/10 text-white min-w-[220px]"
      >
        {models.map((m) => (
          <DropdownMenuItem
            key={m.id}
            data-testid={`model-option-${m.id}`}
            onClick={() => onChange(m.id)}
            className="flex items-center justify-between cursor-pointer focus:bg-[#1F1F22] focus:text-white py-2.5"
          >
            <div className="flex flex-col">
              <span className="text-sm font-medium">{m.label}</span>
              <span className="text-xs text-zinc-500">
                {m.provider}{typeof m.cost === "number" ? ` · ${m.cost} credit${m.cost > 1 ? "s" : ""}/msg` : ""}
              </span>
            </div>
            {value === m.id && <Check className="w-4 h-4 text-[#00FF66]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
